module.exports = __webpack_public_path__ + "static/media/PEL.747df17c.txt";